import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

interface Comparison {
  id: string;
  customer: string;
  customerB: string;
  customerVersion: string;
  targetVersion: string;
  status: string;
  result: string;
  requestedBy: string;
  startTime: string;
  pipelineUrl: string;
}
interface Build {
  id: string;
  templateParameters: {
    customerName?: string;
    customerConfigVersion?: string;
    targetVersion?: string;
    customerA?: string;
    versionA?: string;
    customerB?: string;
    versionB?: string;
  };
  startTime: string;
  status: string;
  result: string;
  requestedBy: {
    displayName: string;
    imageUrl: string;
  };
  url: string;
}
interface Builds {
  count: number;
  value: Build[];
}
@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.css']
})
export class ComparisonComponent implements OnInit {
  gridColumns: any[] = [];
  selectedRowId!: string;
  isLoading = false;
  actionItems!: MenuItem[];
  showConfirmationDialog = false;
  confirmationMessage!: string;
  confirmationAction!: any;
  comparisons: Comparison[] = [];
  comparisonPipelineId = 75;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.gridColumns = [
      { value: 'customer',        header: 'Customer',           width: '15%' },
      { value: 'customerVersion', header: 'Source Version',     width: '15%', type: 'version' },
      { value: 'customerB',       header: 'Comparison Against', width: '15%' },
      { value: 'targetVersion',   header: 'Target Version',     width: '15%', type: 'version' },
      { value: 'result',          header: 'Result',             width: '10%', tag: true },
      { value: 'requestedBy',     header: 'Requested By',       width: '15%' },
      { value: 'startTime',       header: 'Start Time',         width: '30%', type: 'date', dateFormat: 'M/d/yy, h:mm a' },
    ];
    this.reloadGridData();
  }

  reloadGridData() {
    const url = `${environment.buildApiConfig.uri}?definitions=${this.comparisonPipelineId}&api-version=7.1-preview.7`;
    this.fetchComparisons(url);
  }

  fetchComparisons(url: string) {
    this.http.get<Builds>(url)
      .subscribe(builds => {
        this.comparisons = builds.value.map(build => {
          const p = build.templateParameters;
          const customer = p.customerName   ?? p.customerA ?? 'N/A';
          const customerVersion = p.customerConfigVersion ?? p.versionA ?? 'N/A';

          let customerB: string;
          let targetVersion: string;
          if (p.customerB) {
            customerB    = p.customerB;
            targetVersion = p.versionB ?? 'N/A';
          } else {
            customerB    = 'templates';
            targetVersion = p.targetVersion ?? 'N/A';
          }

          return {
            id: build.id,
            customer,
            customerB,
            customerVersion,
            targetVersion,
            status: build.status,
            result: build.result,
            requestedBy: build.requestedBy.displayName,
            startTime: build.startTime,
            pipelineUrl: build.url
          } as Comparison;
        });
      });
  }

  onSelectRowForAction(rowDataAndCurrentActions: any) {
    this.selectedRowId = rowDataAndCurrentActions.rowData.id;
  }

  showConfirmationMessage(message: string) {
    this.confirmationMessage = message;
    this.showConfirmationDialog = true;
  }

  hideConfirmationDialog() {
    this.showConfirmationDialog = false;
  }
}
